import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, withModifiers as _withModifiers, Fragment as _Fragment, createBlock as _createBlock, renderSlot as _renderSlot, renderList as _renderList } from "vue"

const _hoisted_1 = ["disabled"]
const _hoisted_2 = { class: "tw-flex tw-w-full tw-items-center tw-justify-between tw-gap-2" }
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 1,
  class: "tw-aspect-video tw-h-10 tw-self-start tw-rounded tw-bg-slate-100 tw-object-cover dark:tw-bg-slate-700"
}
const _hoisted_5 = {
  key: 2,
  class: "tw-w-full"
}
const _hoisted_6 = { class: "tw-mt-2 tw-flex tw-w-full tw-justify-end tw-gap-2" }
const _hoisted_7 = {
  key: 3,
  class: "tw-flex-1 tw-text-left",
  "data-testid": "video-library-clip-item"
}
const _hoisted_8 = { class: "tw-mb-1 tw-break-words tw-break-all tw-text-sm" }
const _hoisted_9 = { class: "tw-text-xs tw-text-gray-500" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StudioInput = _resolveComponent("StudioInput")!
  const _component_StudioButton = _resolveComponent("StudioButton")!
  const _component_StudioButtonGroup = _resolveComponent("StudioButtonGroup")!
  const _component_StudioAlertBanner = _resolveComponent("StudioAlertBanner")!
  const _component_StudioConfirmationDialog = _resolveComponent("StudioConfirmationDialog")!
  const _component_HLSVideoPreviewDialog = _resolveComponent("HLSVideoPreviewDialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("button", {
      class: _normalizeClass({
        'tw-group tw-w-full': true,
        'tw-p-2': _ctx.allowSelection,
        'hover:tw-opacity-75': _ctx.allowSelection && !_ctx.isRenamingUIVisible,
        'tw-bg-deep-orange-200 tw-p-2 hover:tw-bg-deep-orange-200 hover:tw-bg-opacity-70': _ctx.isSelected
      }),
      disabled: !_ctx.allowSelection || _ctx.isRenamingUIVisible,
      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleSelectVideoAsset && _ctx.handleSelectVideoAsset(...args)))
    }, [
      _createElementVNode("div", _hoisted_2, [
        (!_ctx.showDefaultThumbnail)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass({
            'tw-aspect-video tw-h-10 tw-rounded tw-bg-cover tw-bg-center': true,
            'tw-mb-3': _ctx.isRenamingUIVisible
          }),
              style: _normalizeStyle({ backgroundImage: `url(${_ctx.videoAsset?.urls?.thumbnail})` })
            }, [
              _createElementVNode("img", {
                src: _ctx.videoAsset?.urls?.thumbnail,
                alt: "Fallback Thumbnail",
                style: {"display":"none"},
                onError: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleThumbnailError && _ctx.handleThumbnailError(...args)))
              }, null, 40, _hoisted_3)
            ], 6))
          : (_openBlock(), _createElementBlock("div", _hoisted_4)),
        (_ctx.isRenamingUIVisible)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("form", {
                onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleRenameVideoAsset && _ctx.handleRenameVideoAsset(...args)), ["prevent"]))
              }, [
                _createVNode(_component_StudioInput, {
                  id: "video-asset-new-name-input",
                  ref: "newNameInput",
                  modelValue: _ctx.newName,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.newName) = $event)),
                  maxlength: 255,
                  required: ""
                }, null, 8, ["modelValue"]),
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_StudioButton, {
                    trackingId: "cancel-renaming-video-item-button",
                    size: "small",
                    variant: "outline",
                    disabled: _ctx.isRenaming,
                    onClick: _ctx.hideRenameUI
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Cancel ")
                    ]),
                    _: 1
                  }, 8, ["disabled", "onClick"]),
                  _createVNode(_component_StudioButton, {
                    trackingId: "save-renaming-video-item-button",
                    size: "small",
                    type: "submit",
                    disabled: _ctx.isVisibleActionsDisabled || _ctx.isRenaming
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.isRenaming ? 'Saving...' : 'Save'), 1)
                    ]),
                    _: 1
                  }, 8, ["disabled"])
                ])
              ], 32)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.videoAsset.name), 1),
              _createElementVNode("div", _hoisted_9, [
                (_ctx.videoAsset.status === 'COMPLETE')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(_toDisplayString(_ctx.videoAsset.duration), 1)
                    ], 64))
                  : (_ctx.videoAsset.status === 'ERROR')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(" Error ")
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                        _createTextVNode(" Processing... ")
                      ], 64))
              ])
            ])),
        (!_ctx.isRenamingUIVisible && !_ctx.$slots.actions)
          ? (_openBlock(), _createBlock(_component_StudioButtonGroup, {
              key: 4,
              variant: "outline",
              size: "small",
              class: _normalizeClass(_ctx.alwaysShowActions ? '' : 'tw-hidden group-hover:tw-flex'),
              buttons: _ctx.actionButtons
            }, null, 8, ["class", "buttons"]))
          : _createCommentVNode("", true),
        _renderSlot(_ctx.$slots, "actions")
      ]),
      (_ctx.videoAsset.errors.length > 0)
        ? (_openBlock(), _createBlock(_component_StudioAlertBanner, {
            key: 0,
            type: "error",
            class: "tw-mt-2"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.videoAsset.errors, (error) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: error,
                  class: "tw-mb-1"
                }, _toDisplayString(error), 1))
              }), 128))
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.videoAsset.warnings.length > 0)
        ? (_openBlock(), _createBlock(_component_StudioAlertBanner, {
            key: 1,
            type: "warning",
            class: "tw-mt-2"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.videoAsset.warnings, (warning) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: warning,
                  class: "tw-mb-1"
                }, _toDisplayString(warning), 1))
              }), 128))
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ], 10, _hoisted_1),
    (_ctx.isConfirmingDelete)
      ? (_openBlock(), _createBlock(_component_StudioConfirmationDialog, {
          key: 0,
          type: "error",
          heading: "Are you sure?",
          actionsDisabled: _ctx.isDeleting,
          message: `You are deleting the video <b>${_ctx.videoAsset.name}</b>. This action cannot be undone.`,
          primaryActionTitle: _ctx.isDeleting ? 'Deleting...' : 'Delete',
          secondaryActionTitle: "Cancel",
          onPrimaryAction: _ctx.handleDeleteVideoAsset,
          onSecondaryAction: _ctx.hideDeleteConfirmationDialog
        }, null, 8, ["actionsDisabled", "message", "primaryActionTitle", "onPrimaryAction", "onSecondaryAction"]))
      : _createCommentVNode("", true),
    (_ctx.hlsPreviewVideoAsset)
      ? (_openBlock(), _createBlock(_component_HLSVideoPreviewDialog, {
          key: 1,
          videoAsset: _ctx.hlsPreviewVideoAsset,
          onClose: _cache[4] || (_cache[4] = ($event: any) => (_ctx.hlsPreviewVideoAsset = null))
        }, null, 8, ["videoAsset"]))
      : _createCommentVNode("", true)
  ]))
}